import { Avatar } from "antd";

type CustomAvatarType = {
  imgSrc: string;
  size?: number;
};
const CustomAvatar = ({ imgSrc, size = 62 }: CustomAvatarType) => {
  return (
    <Avatar
      className="CustomAvatar"
      src={imgSrc}
      size={{ xs: size, sm: size, md: size, lg: size, xl: size, xxl: size }}
      alt="no img"
    />
  );
};

export default CustomAvatar;
